import React, { useId } from "react";

/** A label–value row; assistive tech reads it as a group named by its label. */
const DetailRow: React.FunctionComponent<{
  term: React.ReactNode;
  value: React.ReactNode;
}> = ({ term, value }) => {
  const termId = useId();

  return (
    <div
      role="group"
      aria-labelledby={termId}
      className="flex justify-between gap-4 border-b border-gray-200 py-2.5"
    >
      <dt id={termId} className="text-gray-500">
        {term}
      </dt>
      <dd className="break-all text-right font-medium text-gray-900">
        {value || "—"}
      </dd>
    </div>
  );
};

/** Label–value rows; a missing value shows as a dash. */
const DetailList: React.FunctionComponent<{
  rows: [React.ReactNode, React.ReactNode][];
}> = ({ rows }) => (
  <dl className="text-sm">
    {rows.map(([term, value], i) => (
      <DetailRow key={i} term={term} value={value} />
    ))}
  </dl>
);

export default DetailList;
